var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.526 4.217a.75.75 0 0 1 0 1.06L7.81 10l4.716 4.721a.75.75 0 1 1-1.061 1.06l-5.246-5.25a.75.75 0 0 1 0-1.061l5.246-5.252a.75.75 0 0 1 1.06-.001Z",
  clipRule: "evenodd"
})));
export { SvgArrowBack as ReactComponent };